<!-- TODO: dictionary references are in a global json in ecp.web; is this intended? why? -->
<div class="bl-padding-sm--24 bl-text-align--center">
    <div class="bl-max-width--100 bl-margin-x--auto bl-margin-bottom--24">
      <img src="assets/images/warning-icon.svg" alt="" aria-hidden="true" />
    </div>
    <h4 class="bl-font-size--base bl-font-color--steel bl-font-weight--900 bl-margin-bottom--16">
      {{ 'olaLoanGroupChange/heading' | dictionary }}
    </h4>
    <p class="bl-font-color--slate bl-margin-bottom--24">
      {{ 'olaLoanGroupChange/description' | dictionary }}
    </p>
    <div
      class="bl-display--block bl-display-sm--flex bl-flex-direction--row-reverse bl-justify-content--center bl-width-sm--75 bl-margin-x--auto bl-margin-top--32">
      <button type="button" id="changeLoanGroup" (click)="confirmLoanGroupChange()" class="bl-button bl-width--100 bl-margin-bottom--16 bl-margin-bottom-sm--0">
        {{ 'olaLoanGroupChange/confirm' | dictionary }}
      </button>
      <button type="button" id="custom-modal-close" (click)="cancelLoanGroupChangeModal()" class="bl-button bl-button-reverse bl-margin-right--24 bl-width--100">
        {{ 'olaLoanGroupChange/cancel' | dictionary }}
      </button>
    </div>
  </div>